import { SEND_LOW_KEYS_EMAILS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema'

export default {
	[SEND_LOW_KEYS_EMAILS]: {
		payloadSchema: cronJobPayloadSchema,
		isCron: true,
	},
}
